import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApplicationConfig } from '@config/application.config';
import { Constant } from '@common/constant';
import { Store } from '@ngxs/store';

@Injectable()
export class AppVersionInterceptor implements HttpInterceptor {

  constructor(private readonly store: Store) {
  }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.method && (request.url?.indexOf(ApplicationConfig.apiUrl) > -1)) {
      const version = ApplicationConfig.version.substring(0, ApplicationConfig.version.lastIndexOf(' '));
      const appVersionRequest: HttpRequest<any> = request.clone({
        setHeaders: {
          [Constant.HTTP_APP_VERSION_HEADER]: version
        }
      });

      return next.handle(appVersionRequest);
    } else {
      return next.handle(request);
    }
  }
}
